import { useCallback } from "react";
import { useFormContext, UseFormRegisterReturn } from "react-hook-form";

type AdapterOptions<T = any> = {
  name?: string;
  register?: UseFormRegisterReturn<any>;
  onChange?: (e: T) => void;
  onBlur?: (e: any) => void;
  transformEvent?: (e: T) => T;
  setValueAs?: (val: any) => any;
};

export function useRHFAdapter<T = any>({
  name,
  register: externalRegister,
  onChange,
  onBlur,
  transformEvent,
  setValueAs,
}: AdapterOptions<T>) {
  const { register: useFormRegister } = useFormContext();

  const register =
    externalRegister ||
    (name
      ? useFormRegister(name, setValueAs ? { setValueAs } : {})
      : undefined);

  const handleChange = useCallback(
    (e: T) => {
      const transformed = transformEvent ? transformEvent(e) : e;

      onChange?.(transformed);

      register?.onChange?.(transformed as any);
    },
    [transformEvent, onChange, register?.onChange, name]
  );

  const handleBlur = useCallback(
    (e: any) => {
      onBlur?.(e);

      register?.onBlur?.(e);
    },
    [onBlur, register?.onBlur, name]
  );

  const mergedRef = (el: any) => {
    if (typeof register?.ref === "function") {
      register.ref(el);
    }
  };

  return {
    inputProps: {
      onChange: handleChange,
      onBlur: handleBlur,
      ref: mergedRef,
    },
  };
}
